import BaseConstants from "../constants/BaseConstants";
import TagActions from "../actions/TagActions";
import LoginStore from "../stores/LoginStore";
import AppUtils from "./AppUtils";
let jwt = LoginStore.getJwt();

class TagAPI {

  getAllTags() {
    const url = BaseConstants.TAGS_URL;
    jwt = LoginStore.getJwt();
    // console.log({jwt});
    
    const option = {
      token: jwt,
      action: "la",
    };
    fetch(url, {
      method: "POST",
      headers: AppUtils.getAuthHeaders(),
      body: JSON.stringify(option),
    })
      .then((response) => response.json())
      .then((tags) => {
        if (parseInt(tags.code, 10) === 0) {
          // LoginStore.logout();
          // window.location.href = "/login";
        } else {
          TagActions.loadAllTags(tags);
        }
      })
      .catch((error) => {
        TagActions.loadAllTags(error.message);
        return error;
      });
  }

  loadTag(id) {
    const url = BaseConstants.TAGS_URL;
    const option = {
      token: jwt,
      action: "l",
      hashData: {
        id: id,
      },
    };
    fetch(url, {
      method: "POST",
      headers: AppUtils.getAuthHeaders(),
      body: JSON.stringify(option),
    })
      .then((response) => response.json())
      .then((tag) => {
        if (parseInt(tag.code, 10) === 0) {
          // LoginStore.logout();
          // window.location.href = "/login";
        } else {
          TagActions.loadTag(tag);
        }
      })
      .catch((error) => {
        TagActions.loadTag(error.message);
        return error;
      });
  }

  addTag(tag) {
    const url = BaseConstants.TAGS_URL;
    const option = {
      token: jwt,
      action: "i",
      hashData: {
        TagVisible: tag.TagVisible,
        PlotMaxValue: tag.PlotMaxValue,
        TagDispName: tag.TagDispName,
        TagUnit: tag.TagUnit,
        TypeDesc: tag.TypeDesc,
        PlotMinValue: tag.PlotMinValue,
        RejMinValue: tag.RejMinValue,
        TagDesc: tag.TagDesc,
        PlotColor: tag.PlotColor,
        TypeType: tag.TypeType,
        RejMaxValue: tag.RejMaxValue,
        DBArchive: tag.DBArchive,
        TagName: tag.TagName,
        TagOffset: tag.TagOffset,
        Precision: tag.Precision,
        PlotLogScale: tag.PlotLogScale,
        TypeUnitFactor: tag.TypeUnitFactor,
        TypeUnit: tag.TypeUnit,
      },
    };
    return fetch(url, {
      method: "POST",
      headers: AppUtils.getAuthHeaders(),
      body: JSON.stringify(option),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        return error;
      });
  }

  updateTag(tag) {
    const url = BaseConstants.TAGS_URL;
    const data = {
      id: tag.TagKey,
      TagKey: tag.TagKey,
      TypeKey: tag.TagKey,
      TagTypeKey: tag.TagKey,
      TagVisible: tag.TagVisible,
      PlotMaxValue: tag.PlotMaxValue,
      TagDispName: tag.TagDispName,
      TagUnit: tag.TagUnit,
      TypeDesc: tag.TypeDesc,
      PlotMinValue: tag.PlotMinValue,
      RejMinValue: tag.RejMinValue,
      TagDesc: tag.TagDesc,
      PlotColor: tag.PlotColor,
      TypeType: tag.TypeType,
      RejMaxValue: tag.RejMaxValue,
      DBArchive: tag.DBArchive,
      TagName: tag.TagName,
      TagOffset: tag.TagOffset,
      Precision: tag.Precision,
      PlotLogScale: tag.PlotLogScale,
      TypeUnitFactor: tag.TypeUnitFactor,
      TypeUnit: tag.TypeUnit,
    };
    if (tag.TagJEPName !== undefined) {
      data.TagJEPName = tag.TagJEPName
    }
    const option = {
      token: jwt,
      action: "u",
      hashData: data,
    };
    return fetch(url, {
      method: "POST",
      headers: AppUtils.getAuthHeaders(),
      body: JSON.stringify(option),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        return error;
      });
  }

  deleteTag(TagKey) {
    const url = BaseConstants.TAGS_URL;
    const option = {
      token: jwt,
      action: "d",
      hashData: {
        id: TagKey,
        TagKey: TagKey,
        TagTypeKey: TagKey,
      },
    };
    return fetch(url, {
      method: "POST",
      headers: AppUtils.getAuthHeaders(),
      body: JSON.stringify(option),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        return error;
      });
  }

  //state tag---------------------
  getAllStateTags() {
    const url = BaseConstants.STATE_TAGS_URL;
    const option = {
      token: jwt,
      action: "la"
    };
    fetch(url, {
      method: 'POST',
      headers: AppUtils.getAuthHeaders(),
      body: JSON.stringify(option)
    }).then(response => response.json()
    ).then(tags => {
      if (parseInt(tags.code, 10) === 0) {
        // LoginStore.logout();
        // window.location.href = "/login";
      } else {
        TagActions.loadAllStateTags(tags);
      }
    }).catch(error => {
      TagActions.loadAllStateTags(error.message);
      return error;
    });
  }

  loadStateTag(id) {
    const url = BaseConstants.STATE_TAGS_URL;
    const option = {
      token: jwt,
      action: "l",
      hashData: {
        id: id,
      },
    };
    fetch(url, {
      method: "POST",
      headers: AppUtils.getAuthHeaders(),
      body: JSON.stringify(option),
    })
      .then((response) => response.json())
      .then((tag) => {
        if (parseInt(tag.code, 10) === 0) {
          // LoginStore.logout();
          // window.location.href = "/login";
        } else {
          TagActions.loadStateTag(tag);
        }
      })
      .catch((error) => {
        TagActions.loadStateTag(error.message);
        return error;
      });
  }

  addStateTag(tag) {
    const url = BaseConstants.STATE_TAGS_URL;
    const option = {
      token: jwt,
      action: "i",
      hashData: {
        TagVisible: tag.TagVisible,
        PlotMaxValue: tag.PlotMaxValue,
        TagDispName: tag.TagDispName,
        TagUnit: tag.TagUnit,
        TypeDesc: tag.TypeDesc,
        PlotMinValue: tag.PlotMinValue,
        RejMinValue: tag.RejMinValue,
        TagDesc: tag.TagDesc,
        PlotColor: tag.PlotColor,
        TypeType: tag.TypeType,
        RejMaxValue: tag.RejMaxValue,
        DBArchive: tag.DBArchive,
        TagName: tag.TagName,
        TagOffset: tag.TagOffset,
        Precision: tag.Precision,
        PlotLogScale: tag.PlotLogScale,
        TypeUnitFactor: tag.TypeUnitFactor,
        TypeUnit: tag.TypeUnit,
        AllStates: tag.AllStates
      },
    };
    return fetch(url, {
      method: "POST",
      headers: AppUtils.getAuthHeaders(),
      body: JSON.stringify(option),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        return error;
      });
  }

  updateStateTag(tag) {
    // return mockUpdateStateTagsRequest()
    // // .then((resp) =>{ resp.json()})
    // .then((response) => {
    //   return response;
    // })
    // .catch((error) => {
    //   return error
    // });
    const url = BaseConstants.TAGS_URL;
    const option = {
      token: jwt,
      action: "u",
      hashData: {
        id: tag.TagKey,
        TagKey: tag.TagKey,
        TypeKey: tag.TagKey,
        TagTypeKey: tag.TagKey,
        TagVisible: tag.TagVisible,
        PlotMaxValue: tag.PlotMaxValue,
        TagDispName: tag.TagDispName,
        TagUnit: tag.TagUnit,
        TypeDesc: tag.TypeDesc,
        PlotMinValue: tag.PlotMinValue,
        RejMinValue: tag.RejMinValue,
        TagDesc: tag.TagDesc,
        PlotColor: tag.PlotColor,
        TypeType: tag.TypeType,
        RejMaxValue: tag.RejMaxValue,
        DBArchive: tag.DBArchive,
        TagName: tag.TagName,
        TagOffset: tag.TagOffset,
        Precision: tag.Precision,
        PlotLogScale: tag.PlotLogScale,
        TypeUnitFactor: tag.TypeUnitFactor,
        TypeUnit: tag.TypeUnit,
        // AllStates:tag.AllStates
      },
    };
    return fetch(url, {
      method: "POST",
      headers: AppUtils.getAuthHeaders(),
      body: JSON.stringify(option),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        return error;
      });
  }

  updateStates(tagKey, states) {
    const url = BaseConstants.STATE_TAGS_URL;
    const option = {
      token: jwt,
      action: "u",
      hashData: {
        id: tagKey,
        AllStates: states,
      },
    };
    return fetch(url, {
      method: "POST",
      headers: AppUtils.getAuthHeaders(),
      body: JSON.stringify(option),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        return error;
      });
  }

  deleteStateTag(TagKey) {
    const url = BaseConstants.STATE_TAGS_URL;
    const option = {
      token: jwt,
      action: "d",
      hashData: {
        id: TagKey,
        TagKey: TagKey,
        TagTypeKey: TagKey,
      },
    };
    return fetch(url, {
      method: "POST",
      headers: AppUtils.getAuthHeaders(),
      body: JSON.stringify(option),
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        return error;
      });
  }
}

export default new TagAPI();
